<template>
  <div class="resource-item-container" :class="{loading: loading, failed: failed}">

    <template v-if="typeof results !== 'undefined' && results.length">
      <component :is="tag" class="resource-items" :class="listingClasses">
        <component
            :is="type"
            v-for="child in results"
            :key="child.id"
            :data="child"
            @action="triggerAction"
        ></component>
      </component>

      <pagination :current-page="page" :total-pages="totalPages" @change-page="changePage"></pagination>
    </template>
    <template v-else>
      <div class="no-results">
        <p v-html="noResultsMessage"></p>
      </div>
    </template>

    <div class="data-loader">
      <div class="data-loader-inner">
        <div class="data-loader-icon">
          <svg-icon id="loading" class="spin"></svg-icon>
        </div>
        <div class="data-loader-message">Loading data...</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.loadData()
    this.$on('update', this.loadData)
    this.$eventBus.$on(`update_listing_${this.type}`, this.loadData)
  },
  props: {
    dataUrl: {
      type: String,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 25,
    },
    listingClasses: {
      type: Array,
      default () {
        return []
      }
    },
    tag: {
      type: String,
      default: 'div',
    },
    type: {
      type: String,
      required: true,
    },
    noResultsMessage: {
      type: String,
      required: false,
      default: 'There are no results to show here at this time.'
    }
  },
  data () {
    return {
      failed: false,
      loading: false,
      perPage: this.itemsPerPage,
      page: 1,
      results: [],
      totalPages: 1,
    }
  },
  computed: {},
  watch: {
    itemsPerPage () {
      this.loadData()
    },
    page () {
      this.loadData()
    }
  },
  methods: {
    changePage (which) {
      this.page = which
    },
    loadData () {
      if (!this.loading) {
        this.loading = true

        // Check with our backend
        axios.get(this.dataUrl, { params: { page: this.page } })
            .then(response => {
              let data = response.data

              this.results = data.data
              this.page = data.current_page
              this.totalPages = data.last_page
              this.perPage = data.per_page

              this.$nextTick(() => {
                this.loading = false
                this.failed = false
              })
            })
            .catch(() => {
              this.loading = false
              this.failed = true
            })
      }
    },
    triggerAction (e) {
      this.$emit('action', e)
    }
  }
}
</script>
